import { useEffect, useState } from 'react';
import type { SkillGroup } from '@sfc/sdk';
import { platform } from '../api/client';

/**
 * The curated vocabulary, fetched once per screen that needs it.
 *
 * Both halves of this product pick from the same list -- what somebody does,
 * and what an idea is looking for -- because the deck's ranking is the size of
 * the overlap between the two, and an overlap is only arithmetic when both
 * sides are the same kind of thing.
 */
export function useSkills(): { groups: SkillGroup[]; failed: boolean } {
  const [groups, setGroups] = useState<SkillGroup[]>([]);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let live = true;
    void (async () => {
      try {
        const loaded = await platform.match.skills();
        if (live) setGroups(loaded);
      } catch {
        if (live) setFailed(true);
      }
    })();
    return () => {
      live = false;
    };
  }, []);

  return { groups, failed };
}
